import { render, staticRenderFns } from "./CascaderComp.vue?vue&type=template&id=988429d0&"
import script from "./CascaderComp.vue?vue&type=script&lang=js&"
export * from "./CascaderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports